// Botón "Instalar app": instala la PWA. Hotel Depot aún no tiene app nativa, así que
// no hay enlace a tiendas; cuando exista, agregar aquí la URL de Play/App Store.
import { useState } from 'react'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'

const btnCls =
  'mt-4 block w-full rounded-lg border border-ds-500 py-2 text-center text-sm font-medium text-ds-700 hover:bg-ds-50'

export function InstallAppButton() {
  const { canInstall, isIOS, isStandalone, promptInstall } = useInstallPrompt()
  const [showIosHelp, setShowIosHelp] = useState(false)

  if (isStandalone) return null // ya está instalada

  if (isIOS) {
    return (
      <div className="mt-4">
        <button onClick={() => setShowIosHelp((v) => !v)} className={`${btnCls} mt-0`}>
          📲 Instalar app
        </button>
        {showIosHelp && (
          <p className="mt-2 text-xs leading-relaxed text-gray-500">
            En iPhone: toca <b>Compartir</b> (el cuadro con la flecha ↑) y luego{' '}
            <b>“Agregar a pantalla de inicio”</b>.
          </p>
        )}
      </div>
    )
  }

  if (!canInstall) return null // el navegador aún no ofrece instalar

  return (
    <button onClick={promptInstall} className={btnCls}>
      📲 Instalar app
    </button>
  )
}
